import React from 'react';
import Icon from '@mdi/react';
import { mdiChevronRight } from '@mdi/js';
import './sidebar.m.css';

const Sidebar = ({ items, activeIndex, onChange, darkMode = false }) => {
  return (
    <aside styleName={darkMode ? 'sidebar dark' : 'sidebar'}>
      {items?.map((item, index) => (
        <div
          key={item.label}
          styleName={`sidebar-item ${activeIndex === index ? 'active' : ''}`}
          onClick={() => onChange(index)}
        >
          {item.label}
          {activeIndex === index && (
            <Icon path={mdiChevronRight} size="16px" className="desktop-only" />
          )}
        </div>
      ))}
    </aside>
  );
};

export default Sidebar;
